const SkeletonElement = () => <div className="skeleton-wave"></div>;

export default SkeletonElement;
